import { H1 } from "../../components/Text/Text";
import CreateNewProductionCompanyShortBody from "./CreateNewProductionCompanyShortBody";
import CreateNewProductionCompanyShortFooter from "./CreateNewProductionCompanyShortFooter";

import styles from './createNewProductionCompanyShort.module.scss';

export default (prodCompanyName?: string) => ({
    header: <H1>Create new production company</H1>,
    body: <CreateNewProductionCompanyShortBody prodCompanyName={prodCompanyName}/>,
    footer: <CreateNewProductionCompanyShortFooter />,
    className: styles.wrapper,
});